import { cva } from 'class-variance-authority'

export const lemaAiAccentVariants = cva('', {
  variants: {
    isHighlighted: {
      true: 'text-main-foreground-ai',
      false: 'text-main-foreground-tertiary',
    },
  },
  defaultVariants: {
    isHighlighted: false,
  },
})
